/** Client-side host normalization (mirrors backend). */
export function normalizeHost(input: string): string {
  let s = input.trim().toLowerCase();
  if (!s) return '';
  if (!/^https?:\/\//i.test(s)) s = `https://${s}`;
  try {
    const url = new URL(s);
    let host = url.hostname;
    if (host.startsWith('www.')) host = host.slice(4);
    return isRegistrableHost(host) ? host : '';
  } catch {
    const host = s
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .split('/')[0]
      .split(':')[0]
      .split('?')[0];
    return isRegistrableHost(host) ? host : '';
  }
}

function isRegistrableHost(host: string): boolean {
  if (!host || /\s/.test(host)) return false;
  return host.split('.').filter(Boolean).length >= 2;
}

export function faviconUrl(host: string | null | undefined, size = 32): string | null {
  const normalized = host ? normalizeHost(host) : '';
  if (!normalized) return null;
  return `https://www.google.com/s2/favicons?sz=${size}&domain=${encodeURIComponent(normalized)}`;
}
